import { sortBy } from 'lodash';
import config from '~/config';
import http from './http';

const withErrorHandling = async (request) =>{
    try {
        let response = await request();

        if (response.errored) {
            throw new Error(response.error);
        }

        return response;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const addResourceDocument = async (document) => {
    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension,
        description: document.description
    };

    const uri = `${config.urls.base}/user/addResourceDocument`;
    
    return withErrorHandling(() => http.post(uri, upload));
};

export const getResourceDocuments = async () => {
    const url = `${config.urls.base}/user/getResourceDocuments`;

    const result = await withErrorHandling(() => http.get(url));

    return sortBy(result, [doc => doc.File.toLowerCase()]);
};

export const updateResourceDocument = async (id,document) => {
    const upload = {
        name: document.fileName,
        fileSize: document.fileSize,
        typeId: document.typeId,
        uuid: document.cloudFileName,
        path: document.cloudStoragePath,
        extension: document.fileExtension,
        description: document.description
    };
    const uri = `${config.urls.base}/user/updateResourceDocument/${id}`;
    
    return withErrorHandling(() => http.put(uri, upload));
};

export const deleteResourceDocument = async (id) => {

    const uri = `${config.urls.base}/user/deleteResourceDocument/${id}`;
    
    return withErrorHandling(() => http.del(uri));
};

export default {
    addResourceDocument,
    getResourceDocuments,
    updateResourceDocument,
    deleteResourceDocument
};